import { ADD_DEFERRED_PROMPT } from "./deferredPromptReducer"

export const addDeferredPrompt = (obj) => ({
    type: ADD_DEFERRED_PROMPT,
    payload: obj
})